import polyglot from '../../../../../localization';

import { Item } from './Item';

import './styles.scss';

/**
 * GameHighlights component renders a list of key game highlight items
 * for the "Why Fun" section. Each item contains a localized title
 * and description based on the selected language.
 *
 * @param {string} lang — Language key used to localize highlight titles and texts.
 */

export const GameHighlights = ({ lang }) => (
    <div className='game-highlights'>
        <Item
            title={polyglot.t(`${lang}.whyFun.ballControl.title`)}
            description={polyglot.t(`${lang}.whyFun.ballControl.text`)}
        />

        <Item
            title={polyglot.t(`${lang}.whyFun.challenging.title`)}
            description={polyglot.t(`${lang}.whyFun.challenging.text`)}
        />

        <Item
            title={polyglot.t(`${lang}.whyFun.puzzleLike.title`)}
            description={polyglot.t(`${lang}.whyFun.puzzleLike.text`)}
        />

        <Item
            title={polyglot.t(`${lang}.whyFun.customizable.title`)}
            description={polyglot.t(`${lang}.whyFun.customizable.text`)}
        />

        <Item
            title={polyglot.t(`${lang}.whyFun.greatExperience.title`)}
            description={polyglot.t(`${lang}.whyFun.greatExperience.text`)}
        />
    </div>
);
